import moment from "moment";

/**
 * Fecha/hora que el backend de social usa para la cola de publicación.
 *
 * Importante: `Date` de react-date-picker (y otros) a veces representa medianoche **UTC**;
 * `moment(date).format("yyyy-MM-DD")` puede caer **un día antes** en zonas como Argentina (UTC-3).
 * Por eso el día del calendario se toma con getFullYear/getMonth/getDate (hora local del navegador).
 */
export function scheduleDateStringForApiFromDateAndHour(
  date: Date,
  hour: string
): string {
  if (!date || !hour) return "";
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  const ymd = `${y}-${mo}-${d}`;
  const trimmed = hour.trim();
  const parsed = moment(`${ymd} ${trimmed}`, "YYYY-MM-DD HH:mm", true);
  if (parsed.isValid()) {
    /* ISO 8601 UTC: el backend y la cola suelen parsear esto de forma fiable.
       `.toString()` de Moment devuelve texto estilo "Wed Mar 25 2026 … GMT-0300"
       y puede romper o ignorar el job de publicación según el parser del servidor. */
    return parsed.toISOString();
  }
  const loose = moment(`${ymd} ${trimmed}`);
  return loose.isValid() ? loose.toISOString() : "";
}
